module.exports = __webpack_public_path__ + "../../../static/img/c_im_25.51e99a17.png";